import React, { useState } from "react";
import { IGlossaryIconCategory } from "../models/glossary-icons-block-models";
import GlossaryIcon from "./glossary-icon";

//Display glossary icons associated to a particular category.
interface IProps {
    glossaryIconCategory: IGlossaryIconCategory
    id: string
}



const GlossaryIconCategory = (props: IProps) => {

    const [levelsShown, setLevelsShown] = useState({});

    const toggleLevel = id => {
        setLevelsShown(prevLevelsShown => ({
            ...prevLevelsShown,
            [id]: !prevLevelsShown[id]
        }));
    };



    const data = 1;

    return (
        <>
            <div id={`panel-` + props.id} key={props.id} className="glossary-block-panel">
                <div className="glossary-block-panel-header">
                    <h4>{props.glossaryIconCategory.iconCategory}</h4>
                    <button className="glossary-block-panel-btn unbutton" onClick={() => { toggleLevel(props.id) }}>
                        <span className={`glossary-block-panel-trigger  ${levelsShown[props.id] ? 'closed' : 'open'}`}> </span>
                    </button>
                </div>
                {!levelsShown[props.id] &&
                    <div className="glossary-block-icon-list">
                        {props.glossaryIconCategory.glossaryIcons && props.glossaryIconCategory.glossaryIcons ?
                            props.glossaryIconCategory.glossaryIcons.map(icon =>
                                <GlossaryIcon glossaryIcon={icon} />)
                            : null}
                    </div>
                }

            </div>

        </>
    )
}

export default GlossaryIconCategory